import { IMAGE_ACCEPT } from '@/components/account/ImageUploader';

export type Notify = (message: string, severity: 'success' | 'error') => void;

/** Same ceiling as the backend (LOGO_MAX_BYTES — avatars share it). */
export const IMAGE_MAX_BYTES = 2 * 1024 * 1024;

export function extractError(error: any, fallback: string): string {
  return (
    error?.response?.data?.error?.message ||
    error?.response?.data?.message ||
    error?.message ||
    fallback
  );
}

/** Type and size are separate so a photo can be type-checked as picked and
 *  size-checked only AFTER it has been shrunk (a big phone photo is fine). */
export function imageTypeProblem(file: File): string | null {
  return IMAGE_ACCEPT.includes(file.type) ? null : 'Use a PNG, JPG or WebP image';
}
export function imageSizeProblem(file: File): string | null {
  return file.size > IMAGE_MAX_BYTES ? 'Image must be 2MB or smaller' : null;
}
/** A user-facing reason this file can't be uploaded as-is, or null if it's fine. */
export function imageProblem(file: File): string | null {
  return imageTypeProblem(file) ?? imageSizeProblem(file);
}

/** The URL out of an upload response, tolerating both axios shapes the app has used. */
export function uploadedUrl(res: any, pick: (data: any) => string | undefined): string {
  return pick(res?.data) ?? pick(res) ?? '';
}
